import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import useAppContext from '../../../../../context/useAppContext';
import { Card, Icon } from '@weezevent/nacre';

export default function RulesEmpty({ event = null, designId = null, onClick = null, labelButton = null }) {
    const [{ organization }] = useAppContext();
    const history = useHistory();
    const { t } = useTranslation();
    const titleForm = t(`ticket.ticket_design.create_design.no_${event ? 'ticket' : 'event'}`);
    const titleList = t(`ticket.ticket_design.designs.linked_${event ? 'ticket' : 'event'}.empty`);

    const handleClick = React.useCallback(() => {
        let prefix = `/ticket/O${organization.id}/`;
        history.push(`${prefix}${event ? `E${event.id}/settings/` : ''}tickets_design/designs/${designId}`);
    }, [history, organization, event, designId]);

    const subtitleForm = t(`ticket.ticket_design.create_design.link_${event ? 'tickets' : 'events'}`);

    return (
        <Card.EmptyState
            title={designId ? titleList : titleForm}
            subtitle={designId ? null : subtitleForm}
            icon={<Icon name={event && !designId ? 'tickets' : 'calendar-star'} />}
            labelButton={labelButton ? labelButton : designId ? t(`ticket.ticket_design.designs.linked_${event ? 'ticket' : 'event'}.link`) : null}
            onClick={onClick ? onClick : designId ? handleClick : null}
        />
    );
}
